(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
  Apply to any text input. Auto-formats whole numbers with commas
  Strips non digits.
  
  Example of expected results
  input => result
  200 => 200
  20.14 => 2,014
  2000 => 2,000
  20000 => 20,000
  asdf1 => 1
   */

  App.angularApp.directive('mfFormatWholeNumber', [
    '$parse', function($parse) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: (function(_this) {
          return function($scope, elem, attrs, ngModel) {
            return ngModel.$parsers.unshift(function(viewValue) {
              var previous;
              if (viewValue !== '') {
                previous = $scope.previous;
                if (viewValue !== previous) {
                  viewValue = String(viewValue).replace(/[\.\D]/g, '');
                  viewValue = String(viewValue).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
                  $scope.previous = viewValue;
                  ngModel.$setViewValue($scope.previous);
                  ngModel.$render();
                  return $scope.previous;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
